import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import deepmerge from "deepmerge";
import { createContext, useContext, useMemo, useReducer, } from "react";
import { defaultRoutes } from "../../routes/routes.js";
import { appReducer } from "./reducer.js";
export const defaultAppState = {
    walletConnectOpen: false,
    wrongNetworkOpen: false,
    clientSettings: {
        brand: {
            logos: {
                header: _jsx(_Fragment, {}),
                notFound: _jsx(_Fragment, {}),
            },
            buttons: {
                primary: {},
                secondary: {},
            },
        },
        clientNamespace: "",
        clientTranslations: {},
        externalRoutes: {
            faq: "",
            protocol: "",
        },
        includeClaimingFee: true,
    },
    platformLinks: {
        learnMoreAboutWallets: "https://help.sundaeswap.finance/en/collections/3303291-wallets",
    },
};
const AppContext = createContext({
    state: defaultAppState,
    dispatch: () => { },
});
export const AppContextProvider = ({ children, clientSettings, }) => {
    const resolvedState = useMemo(() => deepmerge(defaultAppState, {
        clientSettings: {
            ...clientSettings,
            routes: clientSettings.routes
                ? [...defaultRoutes, ...Object.values(clientSettings.routes)]
                : defaultRoutes,
        },
    }), [clientSettings]);
    const [state, dispatch] = useReducer((appReducer), resolvedState);
    return (_jsx(AppContext.Provider, { value: { state, dispatch }, children: children }));
};
// Utility hook.
export const useAppContext = () => useContext(AppContext);
//# sourceMappingURL=context.js.map